export default __webpack_public_path__ + "static/media/webflow.d42d485c.png";